
export default {
  data() {
    return {
      showHelp: false,
      openHelpSection: null
    }
  },
  methods: {
    openHelp(section) {
      this.openHelpSection = section;
      this.showHelp = true;
    },
    closeHelp() {
      this.showHelp = false;
    }
  }
}
